import { createSlice } from '@reduxjs/toolkit';

import { PodcastEpisodeModel, PodcastModel } from '../../../models/Podcast.model';

export type CurrentPodcastSliceState = {
  currentEpisode: PodcastEpisodeModel;
  currentPodcast: PodcastModel;
  playerRate: number;
  isPodcastPlayerModalVisible: boolean;
};

export const podcastEpisodeInitialState: PodcastEpisodeModel = {
  id: '',
  duration: '',
  audio: '',
  author: '',
  content: '',
  date: '',
  image: '',
  title: '',
  url: '',
  video: '',
  podcastTitle: '',
  podcastLogo: '',
  podcastId: '',
  podcastUrl: '',
  previousId: '',
  nextId: '',
};

const initialState: CurrentPodcastSliceState = {
  currentEpisode: podcastEpisodeInitialState,
  currentPodcast: {
    id: '',
    data: [],
    title: '',
    description: '',
    logo: '',
    url: '',
    author: '',
    explicit: false,
    categories: [],
    current_page: 0,
    last_page: 0,
    total: 0,
  },
  playerRate: 1,
  isPodcastPlayerModalVisible: false,
};

const currentPodcastSlice = createSlice({
  name: 'currentPodcast',
  initialState,
  reducers: {
    updateCurrentPodcast(state, action) {
      state.currentPodcast = action.payload;
    },
    updateCurrentEpisode(state, action) {
      state.currentEpisode = action.payload;
    },
    updatePlayerRate(state, action) {
      state.playerRate = action.payload;
    },
    showPlayerModal(state) {
      state.isPodcastPlayerModalVisible = true;
    },
    hidePlayerModal(state) {
      state.isPodcastPlayerModalVisible = false;
    },
  },
});
export const {
  updateCurrentPodcast,
  updateCurrentEpisode,
  updatePlayerRate,
  showPlayerModal,
  hidePlayerModal,
} = currentPodcastSlice.actions;
export const currentPodcastReducer = currentPodcastSlice.reducer;
